import { createElement, forwardRef, memo, MutableRefObject, RefObject } from "react";
import classNames from "classnames";
import { OverlayScrollbarsComponent, OverlayScrollbarsComponentProps } from "overlayscrollbars-react";

import "overlayscrollbars/css/OverlayScrollbars.css";

export type ScrollbarPropsType = Omit<OverlayScrollbarsComponentProps, "ref"> & {
  ref?: ((instance: OverlayScrollbarsComponent) => void) | RefObject<OverlayScrollbarsComponent> | MutableRefObject<OverlayScrollbarsComponent | undefined> | null
};

export type ScrollbarType = OverlayScrollbarsComponent;

export const Scrollbars = memo<ScrollbarPropsType>(forwardRef<any, ScrollbarPropsType>((({ className, ...props }, ref) => {
  return createElement(OverlayScrollbarsComponent, {
    ref,
    ...props,
    options: {
      ...props?.options,
      className: classNames("os-theme-dark", props.options?.className, className),
      scrollbars: {
        autoHide: "move",
        ...props?.options?.scrollbars,
      },
    },
  });
})));

export default Scrollbars;
